<template>

  <div class="plugin-page">



    <!-- 顶部搜索区域 -->

    <div class="top-search">

      <div class="search-wrap">

        <div class="search-box">

          <i class="fas fa-search search-icon"></i>



          <input

            v-model="searchQuery"

            type="text"

            placeholder="搜索插件..."

            class="search-input"

          />



          <i

            v-if="searchQuery"

            class="fas fa-times-circle clear-icon"

            @click="searchQuery = ''"

          ></i>

        </div>

      </div>

    </div>



    <!-- 主体 -->

    <div class="main-container">

      <div class="main-content">



        <!-- 左侧分类 -->

        <div class="category-panel">

          <div class="category-title-row">

            <div class="category-title">
              插件分类
            </div>

            <div class="category-actions">
              <button
                type="button"
                class="category-action-btn"
                title="新增分类"
                @click="openCategoryManager('add')"
              >
                <i class="el-icon-plus"></i>
              </button>

              <button
                type="button"
                class="category-action-btn"
                title="分类设置"
                @click="openCategoryManager('manage')"
              >
                <i class="el-icon-setting"></i>
              </button>
            </div>

          </div>



          <div class="category-list">



            <button

              v-for="category in filteredCategories"

              :key="category.plus_category_id"

              class="category-item"

              :class="{

                active: currentCategory === category.plus_category_id

              }"

              @click="selectC(category)"

            >

              <div class="category-left">

                <i

                  v-if="category.icon"

                  :class="category.icon"

                  class="category-icon"

                ></i>



                <span class="category-name">

                  {{ category.name }}

                </span>

              </div>



              <div class="category-right">

                <span class="category-count">
                  {{ category.count }}
                </span>

                <span
                  class="category-edit-shortcut"
                  title="编辑分类"
                  @click.stop="openCategoryManager('edit', category)"
                >
                  <i class="el-icon-edit"></i>
                </span>

              </div>

            </button>



          </div>

        </div>



        <!-- 右侧插件区域 -->

        <div class="plugin-area">



          <!-- 顶部 -->

          <div class="plugin-area-header">

            <div>

              <h2 class="plugin-area-title">

                {{ getCurrentCategoryName }}

              </h2>



              <div class="plugin-total">

                共 {{ filteredPlugins.length }} 个插件

              </div>

            </div>

          </div>



          <!-- loading -->

          <div

            v-if="loading"

            class="empty-state"

          >

            <i class="el-icon-loading empty-icon"></i>



            <div class="empty-text">

              正在加载插件...

            </div>

          </div>



          <!-- 插件 -->

          <div

            v-else-if="filteredPlugins.length"

            class="plugin-grid"

          >



            <div

              v-for="plugin in filteredPlugins"

              :key="plugin.access_id"

              class="plugin-card"

            >



              
              <!-- 移动分类 -->
              <button
                type="button"
                class="plugin-move-btn"
                title="移动到其他分类"
                @click.stop.prevent="openMoveDialog(plugin)"
              >
                <i class="el-icon-sort"></i>
                <span>移动</span>
              </button>

              <router-link

                :to="plugin.path"

                class="plugin-link"

              >



                <!-- 卡片头部 -->

                <div class="plugin-header">



                  <!-- 有LOGO -->

                  <div

                    v-if="plugin.logo"

                    class="plugin-avatar"

                  >

                    <img

                      :src="plugin.logo"

                      :alt="plugin.name"

                      class="plugin-avatar-img"

                      @error="handleImageError($event, plugin)"

                    />

                  </div>



                  <!-- 无LOGO -->

                  <div

                    v-else

                    class="plugin-avatar plugin-avatar-text"

                    :style="getAvatarStyle(plugin.name)"

                  >

                    {{ getFirstChar(plugin.name) }}

                  </div>



                  <!-- 标题 -->

                  <div class="plugin-info">



                    <div class="plugin-name-row">



                      <h4

                        class="plugin-name"

                        :title="plugin.name"

                      >

                        {{ plugin.name }}

                      </h4>



                    </div>



                    <div class="plugin-meta">



                      <span

                        v-if="plugin.version"

                        class="plugin-version"

                      >

                        v{{ plugin.version }}

                      </span>



                      <span class="plugin-status">

                        已启用

                      </span>



                    </div>



                  </div>



                </div>



                <!-- 描述 -->

                <div class="plugin-description">

                  {{

                    plugin.description ||

                    plugin.remark ||

                    '暂无插件介绍'

                  }}

                </div>



                <!-- 底部 -->

                <div class="plugin-footer">



                  <div class="plugin-footer-left">

                    <span class="plugin-dot"></span>

                    可使用

                  </div>



                  <div class="plugin-enter">

                    进入插件

                    <i class="el-icon-arrow-right"></i>

                  </div>



                </div>



              </router-link>



            </div>



          </div>



          <!-- 空状态 -->

          <div

            v-else

            class="empty-state"

          >



            <div class="empty-avatar">

              <i class="fas fa-search"></i>

            </div>



            <div class="empty-title">

              暂无相关插件

            </div>



            <div class="empty-text">

              请尝试更换分类或搜索其他关键词

            </div>



          </div>



        </div>



      </div>

    </div>






    <!-- 分类管理 -->
    <el-dialog
      title="分类设置"
      :visible.sync="categoryDialogVisible"
      width="720px"
      :close-on-click-modal="false"
      :append-to-body="true"
      class="category-manager-dialog"
      @closed="resetCategoryManager"
    >
      <div class="category-manager">

        <div class="category-create-box">
          <div class="category-create-title">
            <div>
              <div class="category-create-main">新增分类</div>
              <div class="category-create-desc">
                创建后可以把应用移动到新的分类
              </div>
            </div>
          </div>

          <div class="category-create-form">
            <el-input
              v-model="categoryCreateForm.name"
              size="small"
              maxlength="30"
              show-word-limit
              placeholder="请输入分类名称"
            ></el-input>

            <el-input-number
              v-model="categoryCreateForm.sort"
              size="small"
              :min="0"
              :max="9999"
              controls-position="right"
              class="category-sort-input"
            ></el-input-number>

            <el-button
              type="primary"
              size="small"
              :loading="categoryCreateLoading"
              @click="createCategory"
            >
              新增分类
            </el-button>
          </div>
        </div>


        <div class="category-manage-section">
          <div class="category-manage-header">
            <div>
              <div class="category-manage-title">已有分类</div>
              <div class="category-manage-desc">
                可直接修改名称、排序，空分类可以删除
              </div>
            </div>

            <div class="category-total-text">
              共 {{ categoryEditList.length }} 个分类
            </div>
          </div>


          <div
            class="category-manage-list"
            v-if="categoryEditList.length"
          >
            <div
              class="category-manage-item"
              :class="{
                focused:
                  Number(categoryFocusId) ===
                  Number(item.plus_category_id)
              }"
              v-for="item in categoryEditList"
              :key="item.plus_category_id"
            >
              <div class="category-manage-icon">
                <i :class="item.icon || 'fas fa-cube'"></i>
              </div>

              <div class="category-manage-form">
                <div class="category-field">
                  <div class="category-field-label">分类名称</div>
                  <el-input
                    v-model="item.name"
                    size="small"
                    maxlength="30"
                    placeholder="分类名称"
                  ></el-input>
                </div>

                <div class="category-field">
                  <div class="category-field-label">排序</div>
                  <el-input-number
                    v-model="item.sort"
                    size="small"
                    :min="0"
                    :max="9999"
                    controls-position="right"
                    class="category-row-sort"
                  ></el-input-number>
                </div>

                <div class="category-field">
                  <div class="category-field-label">应用数</div>
                  <div class="category-count-value">
                    {{ getCategoryPluginCount(item.plus_category_id) }}
                  </div>
                </div>
              </div>

              <div class="category-manage-actions">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  :loading="
                    Number(categorySavingId) ===
                    Number(item.plus_category_id)
                  "
                  @click="saveCategory(item)"
                >
                  保存
                </el-button>

                <el-button
                  size="mini"
                  type="danger"
                  plain
                  :disabled="
                    getCategoryPluginCount(
                      item.plus_category_id
                    ) > 0
                  "
                  @click="deleteCategory(item)"
                >
                  删除
                </el-button>
              </div>
            </div>
          </div>

          <div
            class="category-manager-empty"
            v-else
          >
            暂无分类，请先创建一个分类
          </div>

          <div class="category-manager-note">
            <i class="el-icon-info"></i>
            有应用的分类不能直接删除，请先把应用移动到其他分类。
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="categoryDialogVisible = false"
        >
          关闭
        </el-button>
      </span>
    </el-dialog>


    <!-- 移动应用分类 -->
    <el-dialog
      title="移动应用"
      :visible.sync="moveDialogVisible"
      width="460px"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closed="resetMoveDialog"
    >
      <div class="move-dialog-body">

        <div
          class="move-plugin-info"
          v-if="movingPlugin"
        >
          <div
            v-if="movingPlugin.logo"
            class="move-plugin-avatar"
          >
            <img
              :src="movingPlugin.logo"
              :alt="movingPlugin.name"
            />
          </div>

          <div
            v-else
            class="move-plugin-avatar move-plugin-avatar-text"
            :style="getAvatarStyle(movingPlugin.name)"
          >
            {{ getFirstChar(movingPlugin.name) }}
          </div>

          <div class="move-plugin-text">
            <div class="move-plugin-name">
              {{ movingPlugin.name }}
            </div>

            <div class="move-plugin-current">
              当前分类：
              <strong>
                {{ getCategoryName(movingPlugin.plus_category_id) }}
              </strong>
            </div>
          </div>
        </div>

        <div class="move-form-item">
          <div class="move-form-label">
            移动到
          </div>

          <el-select
            v-model="moveForm.plus_category_id"
            placeholder="请选择目标分类"
            style="width: 100%;"
          >
            <el-option
              v-for="category in categories"
              :key="category.plus_category_id"
              :label="category.name"
              :value="category.plus_category_id"
              :disabled="
                movingPlugin &&
                Number(category.plus_category_id) ===
                Number(movingPlugin.plus_category_id)
              "
            >
              <div class="move-option">
                <span>{{ category.name }}</span>

                <span
                  v-if="
                    movingPlugin &&
                    Number(category.plus_category_id) ===
                    Number(movingPlugin.plus_category_id)
                  "
                  class="move-option-current"
                >
                  当前
                </span>
              </div>
            </el-option>
          </el-select>
        </div>

        <div class="move-dialog-tip">
          移动后应用会显示在新的分类下面，不会影响应用权限和功能。
        </div>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="moveDialogVisible = false"
        >
          取消
        </el-button>

        <el-button
          size="small"
          type="primary"
          :loading="moveLoading"
          @click="confirmMove"
        >
          确定移动
        </el-button>
      </span>
    </el-dialog>

  </div>

</template>



<script>

import PlusApi from '@/api/plus.js'

import { getSessionStorage } from '@/utils/base'



export default {

  name: 'PlusList',



  data() {

    return {

      loading: true,



      // 搜索

      searchQuery: '',



      // 当前分类

      currentCategory: '',



      // API原始数据

      listData: [],



      // 分类数据

      categories: [],



      // 插件数据

      plugins: [],



      showAddDialog: false,



      showCategoryDropdown: false,



      newPlugin: {

        name: '',

        plus_category_id: null,

        description: '',

        version: ''

      }
,

      // 移动应用
      moveDialogVisible: false,
      moveLoading: false,
      movingPlugin: null,

      moveForm: {
        plus_category_id: ''
      },

      // 分类管理
      categoryDialogVisible: false,
      categoryCreateLoading: false,
      categorySavingId: 0,
      categoryFocusId: 0,
      categoryEditList: [],

      categoryCreateForm: {
        name: '',
        sort: 100
      }

    }

  },



  computed: {



    /**

     * 有权限并且分类下存在插件的分类

     */

    filteredCategories() {

      return this.categories
        .slice()
        .sort((a, b) => {

          const sortA =
            Number(a.sort || 0)

          const sortB =
            Number(b.sort || 0)

          if (sortA !== sortB) {
            return sortA - sortB
          }

          return (
            Number(a.plus_category_id) -
            Number(b.plus_category_id)
          )

        })

    },



    /**

     * 当前显示的插件

     */

    filteredPlugins() {

      const keyword = (this.searchQuery || '')

        .toLowerCase()

        .trim()



      return this.plugins.filter(plugin => {



        // 当前分类

        const categoryMatch =

          Number(plugin.plus_category_id) === Number(this.currentCategory)



        // 权限

        const permissionMatch =

          this.hasPermission(plugin)



        // 名称

        const name =

          (plugin.name || '').toLowerCase()



        // 描述

        const description =

          (plugin.description || '').toLowerCase()



        // 搜索匹配

        const searchMatch =

          !keyword ||

          name.includes(keyword) ||

          description.includes(keyword)



        return (

          categoryMatch &&

          permissionMatch &&

          searchMatch

        )

      })

    },



    /**

     * 当前分类名称

     */

    getCurrentCategoryName() {

      const category =

        this.categories.find(item => {

          return (

            Number(item.plus_category_id) ===

            Number(this.currentCategory)

          )

        })



      return category

        ? category.name

        : '插件中心'

    }

  },



  methods: {

    /**
     * 打开分类管理
     */
    openCategoryManager(mode, category) {

      this.categoryEditList =
        this.categories
          .map(item => {
            return {
              plus_category_id:
                Number(item.plus_category_id),

              name:
                item.name || '',

              sort:
                Number(item.sort || 0),

              icon:
                item.icon || 'fas fa-cube'
            }
          })
          .sort((a, b) => {
            return (
              Number(a.sort || 0) -
              Number(b.sort || 0)
            )
          })

      this.categoryFocusId =
        category &&
        category.plus_category_id
          ? Number(category.plus_category_id)
          : 0

      this.categoryDialogVisible =
        true

    },


    /**
     * 重置分类管理
     */
    resetCategoryManager() {

      this.categoryCreateLoading = false
      this.categorySavingId = 0
      this.categoryFocusId = 0

      this.categoryCreateForm = {
        name: '',
        sort: 100
      }

      this.categoryEditList = []

    },


    /**
     * 分类应用数
     */
    getCategoryPluginCount(categoryId) {

      return this.plugins.filter(plugin => {

        return (
          Number(plugin.plus_category_id) ===
          Number(categoryId)
        )

      }).length

    },


    /**
     * 新增分类
     */
    async createCategory() {

      const name =
        String(
          this.categoryCreateForm.name || ''
        ).trim()

      if (!name) {

        this.$message({
          message: '请输入分类名称',
          type: 'warning'
        })

        return

      }

      this.categoryCreateLoading = true

      try {

        const res =
          await PlusApi.categorySave({
            plus_category_id: 0,
            name: name,
            sort:
              Number(
                this.categoryCreateForm.sort || 0
              )
          })

        this.$message({
          message:
            (res && res.msg) ||
            '分类创建成功',
          type: 'success'
        })

        this.categoryCreateForm = {
          name: '',
          sort: 100
        }

        await this.getData()

        this.refreshCategoryEditList()

      } catch (error) {

        console.error(
          '新增分类失败：',
          error
        )

      } finally {

        this.categoryCreateLoading = false

      }

    },


    /**
     * 保存分类
     */
    async saveCategory(item) {

      if (
        !item ||
        !item.plus_category_id
      ) {
        return
      }

      const name =
        String(item.name || '').trim()

      if (!name) {

        this.$message({
          message: '分类名称不能为空',
          type: 'warning'
        })

        return

      }

      this.categorySavingId =
        Number(item.plus_category_id)

      try {

        const res =
          await PlusApi.categorySave({
            plus_category_id:
              Number(item.plus_category_id),

            name: name,

            sort:
              Number(item.sort || 0)
          })

        this.$message({
          message:
            (res && res.msg) ||
            '保存成功',
          type: 'success'
        })

        await this.getData()

        this.refreshCategoryEditList()

      } catch (error) {

        console.error(
          '保存分类失败：',
          error
        )

      } finally {

        this.categorySavingId = 0

      }

    },


    /**
     * 删除分类
     */
    async deleteCategory(item) {

      if (
        !item ||
        !item.plus_category_id
      ) {
        return
      }

      const count =
        this.getCategoryPluginCount(
          item.plus_category_id
        )

      if (count > 0) {

        this.$message({
          message:
            '该分类下还有应用，请先移动应用',
          type: 'warning'
        })

        return

      }

      try {

        await this.$confirm(
          '确定删除分类“' +
            item.name +
            '”吗？',
          '删除分类',
          {
            confirmButtonText: '确定删除',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )

      } catch (error) {

        return

      }

      try {

        const res =
          await PlusApi.categoryDelete({
            plus_category_id:
              Number(item.plus_category_id)
          })

        this.$message({
          message:
            (res && res.msg) ||
            '删除成功',
          type: 'success'
        })

        if (
          Number(this.currentCategory) ===
          Number(item.plus_category_id)
        ) {
          this.currentCategory = ''
        }

        await this.getData()

        this.refreshCategoryEditList()

      } catch (error) {

        console.error(
          '删除分类失败：',
          error
        )

      }

    },


    /**
     * 刷新分类编辑列表
     */
    refreshCategoryEditList() {

      this.categoryEditList =
        this.categories
          .map(item => {
            return {
              plus_category_id:
                Number(item.plus_category_id),

              name:
                item.name || '',

              sort:
                Number(item.sort || 0),

              icon:
                item.icon || 'fas fa-cube'
            }
          })
          .sort((a, b) => {
            return (
              Number(a.sort || 0) -
              Number(b.sort || 0)
            )
          })

    },


    /**
     * 打开移动分类弹窗
     */
    openMoveDialog(plugin) {

      if (!plugin || !plugin.access_id) {
        return
      }

      this.movingPlugin = plugin

      this.moveForm.plus_category_id =
        Number(plugin.plus_category_id)

      this.moveDialogVisible = true

    },


    /**
     * 获取分类名称
     */
    getCategoryName(categoryId) {

      const category =
        this.categories.find(item => {
          return (
            Number(item.plus_category_id) ===
            Number(categoryId)
          )
        })

      return category
        ? category.name
        : '未分类'

    },


    /**
     * 重置移动弹窗
     */
    resetMoveDialog() {

      this.moveLoading = false
      this.movingPlugin = null
      this.moveForm.plus_category_id = ''

    },


    /**
     * 确认移动应用
     */
    async confirmMove() {

      if (
        !this.movingPlugin ||
        !this.movingPlugin.access_id
      ) {
        return
      }

      const targetCategoryId =
        Number(this.moveForm.plus_category_id)

      const oldCategoryId =
        Number(this.movingPlugin.plus_category_id)

      if (!targetCategoryId) {

        this.$message({
          message: '请选择目标分类',
          type: 'warning'
        })

        return

      }

      if (
        targetCategoryId ===
        oldCategoryId
      ) {

        this.$message({
          message: '应用已经在当前分类中',
          type: 'warning'
        })

        return

      }

      const targetCategoryName =
        this.getCategoryName(
          targetCategoryId
        )

      try {

        await this.$confirm(
          '确定将“' +
            this.movingPlugin.name +
            '”移动到“' +
            targetCategoryName +
            '”吗？',
          '移动应用',
          {
            confirmButtonText: '确定移动',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )

      } catch (error) {

        return

      }

      this.moveLoading = true

      try {

        const res =
          await PlusApi.moveCategory({
            access_id:
              this.movingPlugin.access_id,

            plus_category_id:
              targetCategoryId
          })

        this.$message({
          message:
            (res && res.msg) ||
            '移动成功',
          type: 'success'
        })

        this.currentCategory =
          targetCategoryId

        this.moveDialogVisible =
          false

        await this.getData()

      } catch (error) {

        console.error(
          '移动应用失败：',
          error
        )

      } finally {

        this.moveLoading = false

      }

    },





    /**

     * 分类选择

     */

    selectCategory(plus_category_id) {

      this.showCategoryDropdown = false



      this.currentCategory =

        plus_category_id

    },



    /**

     * 点击分类

     */

    selectC(item) {

      this.currentCategory =

        item.plus_category_id

    },



    /**

     * 请求插件数据

     */

    async getData() {

      this.loading = true



      try {

        const res =

          await PlusApi.plusList({}, true)



        if (

          res &&

          res.data &&

          Array.isArray(res.data.list)

        ) {

          this.listData =

            res.data.list

        } else {

          this.listData = []

        }



        this.processData()



      } catch (error) {



        console.error(

          '获取插件列表失败：',

          error

        )



        this.listData = []

        this.categories = []

        this.plugins = []



      } finally {



        this.loading = false



      }

    },



    /**

     * 处理API数据

     */

    processData() {

      this.categories = []

      this.plugins = []

      if (!Array.isArray(this.listData)) {
        return
      }

      this.listData.forEach(category => {

        const children =
          Array.isArray(category.children)
            ? category.children
            : []

        const newCategory = {

          plus_category_id:
            Number(category.plus_category_id),

          name:
            category.name ||
            '其他',

          icon:
            category.icon ||
            'fas fa-cube',

          sort:
            Number(category.sort || 0),

          count:
            children.filter(child => {
              return this.hasPermission(child)
            }).length

        }

        if (newCategory.plus_category_id) {

          this.categories.push(
            newCategory
          )

        }

        children.forEach(plugin => {

          if (
            this.hasPermission(plugin)
          ) {

            this.plugins.push({

              access_id:
                plugin.access_id ||
                plugin.id ||
                plugin.path,

              id:
                plugin.id,

              plus_category_id:
                Number(
                  category.plus_category_id
                ),

              name:
                plugin.name ||
                '未命名插件',

              description:
                plugin.remark ||
                plugin.description ||
                '',

              remark:
                plugin.remark ||
                '',

              version:
                plugin.version ||
                '',

              path:
                plugin.path ||
                '/',

              ico:
                plugin.ico ||
                '',

              logo:
                plugin.logo ||
                ''

            })

          }

        })

      })

      if (
        this.categories.length > 0
      ) {

        const exists =
          this.categories.some(item => {

            return (
              Number(item.plus_category_id) ===
              Number(this.currentCategory)
            )

          })

        if (!exists) {

          this.currentCategory =
            this.filteredCategories[0]
              .plus_category_id

        }

      } else {

        this.currentCategory = ''

      }

    },


    /**

     * 权限判断

     */

    hasPermission(plugin) {



      if (!plugin) {

        return false

      }



      const authList =

        getSessionStorage('authlist') ||

        {}



      const path =

        plugin.path

          ? String(plugin.path)

              .toLowerCase()

          : ''



      if (!path) {

        return false

      }



      return authList[path] === true

    },



    /**

     * 分类权限

     */

    hasCategoryPermission(category) {



      if (

        !category ||

        !Array.isArray(category.children)

      ) {

        return false

      }



      return category.children.some(

        child => {

          return this.hasPermission(

            child

          )

        }

      )

    },



    /**

     * 获取插件名称首字符

     *

     * 商城 -> 商

     * 分销 -> 分

     * AI助手 -> A

     * CRM -> C

     */

    getFirstChar(name) {



      if (!name) {

        return '插'

      }



      const text =

        String(name).trim()



      if (!text) {

        return '插'

      }



      return text

        .charAt(0)

        .toUpperCase()

    },



    /**

     * 根据名称自动生成固定头像颜色

     */

    getAvatarStyle(name) {



      const colors = [

        {

          background: '#EEF4FF',

          color: '#3370FF'

        },

        {

          background: '#F0FDF4',

          color: '#16A34A'

        },

        {

          background: '#FFF7ED',

          color: '#EA580C'

        },

        {

          background: '#FDF2F8',

          color: '#DB2777'

        },

        {

          background: '#F5F3FF',

          color: '#7C3AED'

        },

        {

          background: '#ECFEFF',

          color: '#0891B2'

        },

        {

          background: '#FFF1F2',

          color: '#E11D48'

        },

        {

          background: '#F0F9FF',

          color: '#0284C7'

        },

        {

          background: '#FEFCE8',

          color: '#CA8A04'

        },

        {

          background: '#F3F4F6',

          color: '#4B5563'

        }

      ]



      let hash = 0



      const text =

        name

          ? String(name)

          : ''



      for (

        let i = 0;

        i < text.length;

        i++

      ) {



        hash =

          text.charCodeAt(i) +

          ((hash << 5) - hash)



      }



      const index =

        Math.abs(hash) %

        colors.length



      return {

        background:

          colors[index].background,



        color:

          colors[index].color

      }

    },



    /**

     * 图片加载失败

     *

     * 比如数据库里有logo地址

     * 但图片404，也自动切换成文字头像

     */

    handleImageError(event, plugin) {



      if (event && event.target) {

        event.target.style.display =

          'none'

      }



      if (plugin) {

        this.$set(

          plugin,

          'logo',

          ''

        )

      }

    },



    /**

     * 原图标方法

     */

    hasIcon(ico) {



      return (

        ico &&

        ico.length > 0

      )

        ? ico

        : '#icon-shop-applications'

    }

  },



  created() {

    this.getData()

  }

}

</script>



<style scoped>



/* ==============================

   页面

\============================== */



.plugin-page {

  width: 100%;

  min-height: 100vh;

  padding: 0;

  margin: 0;

  background: #f6f7f9;

  box-sizing: border-box;

}



/* ==============================

   顶部搜索

\============================== */



.top-search {

  position: relative;

  z-index: 20;

  width: 100%;

  padding: 16px 20px 12px;

  background: #ffffff;

  border-bottom: 1px solid #f0f1f2;

  box-sizing: border-box;

}



.search-wrap {

  width: 100%;

}



.search-box {

  position: relative;

  width: 100%;

}



.search-input {

  width: 100%;

  height: 42px;



  padding:

    0

    42px

    0

    40px;



  box-sizing: border-box;



  color: #1f2329;



  font-size: 14px;



  background: #f5f6f7;



  border:

    1px solid

    transparent;



  border-radius: 9px;



  outline: none;



  transition:

    all

    0.2s

    ease;

}



.search-input:hover {

  background: #f2f3f5;

}



.search-input:focus {

  background: #ffffff;



  border-color:

    #3370ff;



  box-shadow:

    0

    0

    0

    3px

    rgba(51, 112, 255, 0.08);

}



.search-input::placeholder {

  color: #a7abb2;

}



.search-icon {

  position: absolute;



  z-index: 2;



  top: 50%;

  left: 14px;



  color: #8f959e;



  font-size: 14px;



  transform:

    translateY(-50%);



  pointer-events:

    none;

}



.clear-icon {

  position: absolute;



  top: 50%;

  right: 14px;



  color: #c1c5cd;



  font-size: 14px;



  cursor: pointer;



  transform:

    translateY(-50%);



  transition:

    color

    0.2s

    ease;

}



.clear-icon:hover {

  color: #86909c;

}



/* ==============================

   主体

\============================== */



.main-container {

  width: 100%;

  padding: 18px 20px 30px;

  box-sizing: border-box;

}



.main-content {

  display: flex;

  align-items: flex-start;

  width: 100%;

  gap: 20px;

}



/* ==============================

   左侧分类

\============================== */



.category-panel {

  position: sticky;

  top: 20px;



  flex-shrink: 0;



  width: 220px;



  padding: 16px;



  box-sizing: border-box;



  background: #ffffff;



  border:

    1px solid

    #edf0f5;



  border-radius: 12px;



  box-shadow:

    0

    2px

    10px

    rgba(31, 35, 41, 0.03);

}



.category-title {

  padding:

    2px

    8px

    14px;



  color: #1f2329;



  font-size: 16px;



  font-weight: 600;

}



.category-list {

  display: flex;

  flex-direction: column;

  gap: 4px;

}



.category-item {

  position: relative;



  display: flex;



  align-items: center;



  justify-content:

    space-between;



  width: 100%;



  height: 42px;



  padding:

    0

    11px;



  box-sizing: border-box;



  color: #4e5969;



  font-size: 14px;



  text-align: left;



  background:

    transparent;



  border: none;



  border-radius: 8px;



  cursor: pointer;



  outline: none;



  transition:

    all

    0.2s

    ease;

}



.category-item:hover {

  color: #1f2329;

  background: #f5f6f7;

}



.category-item.active {

  color: #3370ff;



  font-weight: 500;



  background:

    #eef4ff;

}



.category-item.active::before {

  position: absolute;



  top: 11px;

  left: 0;



  width: 3px;

  height: 20px;



  background:

    #3370ff;



  border-radius:

    0

    3px

    3px

    0;



  content: "";

}



.category-left {

  display: flex;

  align-items: center;

  min-width: 0;

}



.category-icon {

  flex-shrink: 0;



  width: 22px;



  margin-right: 8px;



  font-size: 14px;



  text-align: center;

}



.category-name {

  overflow: hidden;



  text-overflow:

    ellipsis;



  white-space:

    nowrap;

}



.category-count {

  display: flex;



  flex-shrink: 0;



  align-items: center;



  justify-content:

    center;



  min-width: 22px;



  height: 20px;



  padding:

    0

    6px;



  box-sizing:

    border-box;



  color: #8f959e;



  font-size: 11px;



  background:

    #f5f6f7;



  border-radius:

    10px;

}



.category-item.active

.category-count {

  color: #3370ff;



  background:

    rgba(

      51,

      112,

      255,

      0.08

    );

}



/* ==============================

   右侧

\============================== */



.plugin-area {

  flex: 1;

  min-width: 0;

}



.plugin-area-header {

  display: flex;



  align-items:

    center;



  justify-content:

    space-between;



  min-height: 46px;



  margin-bottom:

    12px;

}



.plugin-area-title {

  padding: 0;

  margin: 0;



  color: #1f2329;



  font-size: 18px;



  font-weight: 600;



  line-height: 26px;

}



.plugin-total {

  margin-top: 3px;



  color: #8f959e;



  font-size: 12px;

}



/* ==============================

   插件网格

\============================== */



.plugin-grid {

  display: grid;



  grid-template-columns:

    repeat(

      4,

      minmax(

        0,

        1fr

      )

    );



  gap: 16px;

}



/* ==============================

   卡片

\============================== */



.plugin-card {

  position: relative;



  min-width: 0;



  min-height: 174px;



  overflow: hidden;



  background:

    #ffffff;



  border:

    1px solid

    #edf0f5;



  border-radius:

    12px;



  box-shadow:

    0

    1px

    2px

    rgba(

      31,

      35,

      41,

      0.02

    );



  transition:

    transform

      0.2s

      ease,

    box-shadow

      0.2s

      ease,

    border-color

      0.2s

      ease;

}



.plugin-card:hover {

  z-index: 2;



  border-color:

    #d9e4ff;



  transform:

    translateY(-3px);



  box-shadow:

    0

    10px

    28px

    rgba(

      31,

      35,

      41,

      0.08

    );

}



.plugin-link {

  display: flex;



  flex-direction:

    column;



  width: 100%;

  height: 100%;



  min-height:

    174px;



  padding: 16px;



  box-sizing:

    border-box;



  color: inherit;



  text-decoration:

    none;

}



/* ==============================

   卡片头部

\============================== */



.plugin-header {

  display: flex;



  align-items:

    center;



  width: 100%;



  margin-bottom:

    14px;

}



/* ==============================

   插件头像

\============================== */



.plugin-avatar {

  display: flex;



  flex-shrink: 0;



  align-items:

    center;



  justify-content:

    center;



  width: 50px;

  height: 50px;



  margin-right:

    12px;



  overflow: hidden;





  border-radius:

    12px;





}



.plugin-avatar-img {

  display: block;



  width: 100%;

  height: 100%;



  object-fit:

    cover;

}



.plugin-avatar-text {

  font-size: 21px;



  font-weight: 600;



  line-height: 1;



  letter-spacing:

    0;



  user-select:

    none;

}



/* ==============================

   插件标题

\============================== */



.plugin-info {

  flex: 1;

  min-width: 0;

}



.plugin-name-row {

  display: flex;



  align-items:

    center;



  min-width: 0;

}



.plugin-name {

  width: 100%;



  padding: 0;

  margin:

    0

    0

    6px;



  overflow: hidden;



  color:

    #1f2329;



  font-size: 15px;



  font-weight: 600;



  line-height:

    21px;



  text-overflow:

    ellipsis;



  white-space:

    nowrap;

}



.plugin-meta {

  display: flex;



  align-items:

    center;



  gap: 6px;

}



.plugin-version {

  display: inline-flex;



  align-items:

    center;



  height: 19px;



  padding:

    0

    6px;



  color:

    #86909c;



  font-size:

    10px;



  line-height:

    19px;



  background:

    #f5f6f7;



  border-radius:

    4px;

}



.plugin-status {

  display:

    inline-flex;



  align-items:

    center;



  height: 19px;



  padding:

    0

    6px;



  color:

    #16a34a;



  font-size:

    10px;



  line-height:

    19px;



  background:

    #f0fdf4;



  border-radius:

    4px;

}



/* ==============================

   描述

\============================== */



.plugin-description {

  display:

    -webkit-box;



  min-height:

    38px;



  margin-bottom:

    12px;



  overflow:

    hidden;



  color:

    #86909c;



  font-size:

    12px;



  line-height:

    19px;



  -webkit-box-orient:

    vertical;



  -webkit-line-clamp:

    2;

}



/* ==============================

   底部

\============================== */



.plugin-footer {

  display: flex;



  align-items:

    center;



  justify-content:

    space-between;



  margin-top:

    auto;



  padding-top:

    11px;



  border-top:

    1px solid

    #f2f3f5;

}



.plugin-footer-left {

  display: flex;



  align-items:

    center;



  color:

    #a2a7ae;



  font-size:

    11px;

}



.plugin-dot {

  width: 6px;

  height: 6px;



  margin-right:

    5px;



  background:

    #22c55e;



  border-radius:

    50%;

}



.plugin-enter {

  color:

    #86909c;



  font-size:

    12px;



  transition:

    color

    0.2s

    ease;

}



.plugin-enter i {

  margin-left:

    2px;



  font-size:

    11px;



  transition:

    transform

    0.2s

    ease;

}



.plugin-card:hover

.plugin-enter {

  color:

    #3370ff;

}



.plugin-card:hover

.plugin-enter

i {

  transform:

    translateX(2px);

}



/* ==============================

   空状态

\============================== */



.empty-state {

  display: flex;



  flex-direction:

    column;



  align-items:

    center;



  justify-content:

    center;



  min-height:

    360px;



  color:

    #86909c;

}



.empty-avatar {

  display: flex;



  align-items:

    center;



  justify-content:

    center;



  width: 56px;

  height: 56px;



  margin-bottom:

    14px;



  color:

    #a6abb3;



  font-size:

    20px;



  background:

    #eef0f3;



  border-radius:

    16px;

}



.empty-title {

  margin-bottom:

    6px;



  color:

    #4e5969;



  font-size:

    14px;



  font-weight:

    500;

}



.empty-text {

  color:

    #a2a7ae;



  font-size:

    12px;

}



.empty-icon {

  margin-bottom:

    10px;



  color:

    #3370ff;



  font-size:

    24px;

}



/* ==============================

   原有兼容样式

\============================== */



.plus-container {

  min-height:

    400px;

}



.plus-container

.common-form {

  margin-bottom:

    0;

}



input[type="number"]::-webkit-inner-spin-button,

input[type="number"]::-webkit-outer-spin-button {

  margin: 0;



  -webkit-appearance:

    none;

}



textarea {

  resize: none;

}



/* ==============================

   响应式

\============================== */



@media screen and (max-width: 1500px) {



  .plugin-grid {

    grid-template-columns:

      repeat(

        3,

        minmax(

          0,

          1fr

        )

      );

  }



}



@media screen and (max-width: 1200px) {



  .category-panel {

    width: 200px;

  }



  .plugin-grid {

    grid-template-columns:

      repeat(

        3,

        minmax(

          0,

          1fr

        )

      );

  }



}



@media screen and (max-width: 1000px) {



  .plugin-grid {

    grid-template-columns:

      repeat(

        2,

        minmax(

          0,

          1fr

        )

      );

  }



}



@media screen and (max-width: 760px) {



  .main-content {

    display: block;

  }



  .category-panel {

    position: static;



    width: 100%;



    margin-bottom:

      16px;

  }



  .category-list {

    display: grid;



    grid-template-columns:

      repeat(

        2,

        minmax(

          0,

          1fr

        )

      );

  }



  .plugin-grid {

    grid-template-columns:

      1fr;

  }



}





/* ==============================
   移动分类
============================== */

.plugin-move-btn {
  position: absolute;
  z-index: 10;
  top: 10px;
  right: 10px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  height: 30px;
  padding: 0 9px;

  color: #86909c;
  font-size: 12px;

  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 7px;

  cursor: pointer;

  opacity: 0;
  transform: translateY(-2px);

  transition:
    opacity 0.18s ease,
    transform 0.18s ease,
    color 0.18s ease,
    background 0.18s ease,
    border-color 0.18s ease;
}

.plugin-card:hover .plugin-move-btn {
  opacity: 1;
  transform: translateY(0);
}

.plugin-move-btn:hover {
  color: #3370ff;
  background: #f5f8ff;
  border-color: #cbd9ff;
}

.plugin-move-btn i {
  margin-right: 4px;
  font-size: 13px;
}

.move-dialog-body {
  padding: 2px 0 4px;
}

.move-plugin-info {
  display: flex;
  align-items: center;

  padding: 14px;

  background: #f7f8fa;
  border-radius: 10px;
}

.move-plugin-avatar {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 48px;
  height: 48px;

  margin-right: 12px;

  overflow: hidden;

  border-radius: 11px;
}

.move-plugin-avatar img {
  display: block;

  width: 100%;
  height: 100%;

  object-fit: cover;
}

.move-plugin-avatar-text {
  font-size: 20px;
  font-weight: 600;
}

.move-plugin-text {
  flex: 1;
  min-width: 0;
}

.move-plugin-name {
  overflow: hidden;

  color: #1f2329;

  font-size: 15px;
  font-weight: 600;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.move-plugin-current {
  margin-top: 5px;

  color: #8f959e;

  font-size: 12px;
}

.move-plugin-current strong {
  color: #4e5969;
  font-weight: 500;
}

.move-form-item {
  margin-top: 20px;
}

.move-form-label {
  margin-bottom: 8px;

  color: #4e5969;

  font-size: 13px;
  font-weight: 500;
}

.move-dialog-tip {
  margin-top: 12px;

  color: #a2a7ae;

  font-size: 12px;
  line-height: 20px;
}

.move-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.move-option-current {
  color: #a2a7ae;
  font-size: 11px;
}

@media screen and (max-width: 760px) {
  .plugin-move-btn {
    opacity: 1;
    transform: none;
  }
}



/* ==============================
   分类快捷管理
============================== */
.category-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 4px 12px 8px;
}

.category-title-row .category-title {
  padding: 0;
}

.category-actions {
  display: flex;
  align-items: center;
  gap: 5px;
}

.category-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  color: #86909c;
  background: #f5f6f7;
  border: 1px solid transparent;
  border-radius: 7px;
  cursor: pointer;
  transition: all .18s ease;
}

.category-action-btn:hover {
  color: #3370ff;
  background: #eef4ff;
  border-color: #d9e4ff;
}

.category-right {
  display: flex;
  align-items: center;
  gap: 5px;
}

.category-edit-shortcut {
  display: none;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  color: #8f959e;
  border-radius: 6px;
  cursor: pointer;
}

.category-item:hover .category-edit-shortcut {
  display: inline-flex;
}

.category-edit-shortcut:hover {
  color: #3370ff;
  background: #eef4ff;
}


/* ==============================
   分类设置弹窗
============================== */
.category-manager {
  padding: 2px 0 4px;
}

.category-create-box {
  padding: 16px;
  background: linear-gradient(135deg, #f8faff, #f5f7fb);
  border: 1px solid #e8edf7;
  border-radius: 12px;
}

.category-create-main {
  color: #1f2329;
  font-size: 15px;
  font-weight: 600;
}

.category-create-desc {
  margin-top: 4px;
  color: #8f959e;
  font-size: 12px;
}

.category-create-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 120px 92px;
  gap: 10px;
  margin-top: 14px;
}

.category-sort-input {
  width: 120px !important;
}

.category-manage-section {
  margin-top: 22px;
}

.category-manage-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 12px;
}

.category-manage-title {
  color: #1f2329;
  font-size: 15px;
  font-weight: 600;
}

.category-manage-desc {
  margin-top: 4px;
  color: #8f959e;
  font-size: 12px;
}

.category-total-text {
  color: #a2a7ae;
  font-size: 12px;
}

.category-manage-list {
  max-height: 430px;
  overflow-y: auto;
  border: 1px solid #edf0f5;
  border-radius: 12px;
}

.category-manage-item {
  display: flex;
  align-items: center;
  padding: 14px;
  border-bottom: 1px solid #f0f1f2;
  transition: background .18s ease;
}

.category-manage-item:last-child {
  border-bottom: 0;
}

.category-manage-item:hover {
  background: #fafbfc;
}

.category-manage-item.focused {
  background: #f5f8ff;
  box-shadow: inset 3px 0 0 #3370ff;
}

.category-manage-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-right: 12px;
  color: #3370ff;
  background: #eef4ff;
  border-radius: 10px;
  font-size: 15px;
}

.category-manage-form {
  display: grid;
  flex: 1;
  grid-template-columns: minmax(160px, 1fr) 110px 70px;
  gap: 10px;
  min-width: 0;
}

.category-field-label {
  margin-bottom: 5px;
  color: #a2a7ae;
  font-size: 11px;
}

.category-row-sort {
  width: 110px !important;
}

.category-count-value {
  display: flex;
  align-items: center;
  height: 32px;
  color: #4e5969;
  font-size: 13px;
  font-weight: 500;
}

.category-manage-actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: 12px;
}

.category-manager-note {
  display: flex;
  align-items: flex-start;
  margin-top: 12px;
  padding: 10px 12px;
  color: #8f959e;
  font-size: 12px;
  line-height: 18px;
  background: #f7f8fa;
  border-radius: 8px;
}

.category-manager-note i {
  margin: 2px 6px 0 0;
  color: #3370ff;
}

.category-manager-empty {
  padding: 42px 20px;
  color: #a2a7ae;
  font-size: 13px;
  text-align: center;
  border: 1px dashed #dfe3e8;
  border-radius: 10px;
}

@media screen and (max-width: 760px) {
  .category-edit-shortcut {
    display: inline-flex;
  }

  .category-create-form {
    grid-template-columns: 1fr;
  }

  .category-sort-input {
    width: 100% !important;
  }

  .category-manage-item {
    align-items: flex-start;
  }

  .category-manage-form {
    grid-template-columns: 1fr;
  }

  .category-manage-actions {
    flex-direction: column;
    gap: 6px;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/plus/plus/index.vue